import { api } from "@/modules/api";

// Response types - defined manually since backend types may not be generated yet
export interface NoteEventInternalResponseSchema {
  id: string;
  kind: string;
  occurred_at: string;
  properties_json: Record<string, unknown>;
}

export interface GetNoteEventsInternalResponseSchema {
  events: NoteEventInternalResponseSchema[];
  total: number;
}

// Note: Using type assertions because OpenAPI types haven't been regenerated yet
// Once types are regenerated, these can be updated to use the proper typed paths

export const fetchNoteEventsInternal = async (
  noteId: string
): Promise<GetNoteEventsInternalResponseSchema | null> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = await (api.get as any)(`/internal/v1/notes/${noteId}/events`, {});

  return response.data ?? null;
};
